import type { GetBannersParams, TBannersList } from '../interfaces/advertising';
import { DecoratedBannersList } from '../interfaces/advertising';
import { decorateBanners } from '../utils/decorateBanners';

import ProxyClient from './clients/ProxyClient';

export const loadBanners = async ({ params }: { params: GetBannersParams }): Promise<DecoratedBannersList> => {
  const { data } = await ProxyClient.get<TBannersList>('/banners', { params });

  return decorateBanners(data);
};
